import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import axios from "axios";

import "./LoginAdmin.css";

const API =
  process.env.NODE_ENV === "production"
    ? "https://gj-frio-industrial-api.onrender.com"
    : "http://localhost:4000";

export default function LoginAdmin() {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState("");

  const [password, setPassword] = useState("");

  const [mostrarPassword, setMostrarPassword] = useState(false);

  const [cargando, setCargando] = useState(false);

  const [mensaje, setMensaje] = useState("");

  /* =======================================================
     SI YA EXISTE SESIÓN
  ======================================================= */

  useEffect(() => {
    const token = sessionStorage.getItem("gj_admin_token");

    if (!token) return;

    const verificar = async () => {
      try {
        await axios.get(`${API}/auth/verificar`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        navigate("/admin", {
          replace: true,
        });
      } catch {
        sessionStorage.removeItem("gj_admin_token");

        sessionStorage.removeItem("gj_admin_usuario");
      }
    };

    verificar();
  }, [navigate]);

  /* =======================================================
     LOGIN
  ======================================================= */

  const iniciarSesion = async (e) => {
    e.preventDefault();

    setMensaje("");

    if (!usuario.trim() || !password) {
      setMensaje("Ingrese el usuario y la contraseña.");

      return;
    }

    try {
      setCargando(true);

      const respuesta = await axios.post(`${API}/auth/login`, {
        usuario: usuario.trim(),
        password,
      });
      sessionStorage.setItem("gj_admin_token", respuesta.data.token);

      sessionStorage.setItem(
        "gj_admin_usuario",
        JSON.stringify(respuesta.data.admin),
      );

      navigate("/admin", {
        replace: true,
      });
    } catch (error) {
      setMensaje(error.response?.data?.message || "No se pudo iniciar sesión.");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <div className="admin-login-lock">
            <i className="bi bi-shield-lock-fill"></i>
          </div>

          <span className="admin-login-kicker">G&amp;J FRÍO</span>

          <h1>Administración</h1>

          <p>Acceso exclusivo para personal autorizado.</p>
        </div>

        <form onSubmit={iniciarSesion} className="admin-login-form">
          <div className="admin-login-field">
            <label htmlFor="adminUsuario">Usuario</label>

            <div className="admin-login-input">
              <i className="bi bi-person"></i>

              <input
                id="adminUsuario"
                type="text"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                placeholder="Ingrese su usuario"
                autoComplete="username"
                autoFocus
              />
            </div>
          </div>

          <div className="admin-login-field">
            <label htmlFor="adminPassword">Contraseña</label>

            <div className="admin-login-input">
              <i className="bi bi-lock"></i>

              <input
                id="adminPassword"
                type={mostrarPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingrese su contraseña"
                autoComplete="current-password"
              />

              <button
                type="button"
                className="admin-password-button"
                onClick={() => setMostrarPassword((prev) => !prev)}
                aria-label={
                  mostrarPassword ? "Ocultar contraseña" : "Mostrar contraseña"
                }
              >
                <i
                  className={mostrarPassword ? "bi bi-eye-slash" : "bi bi-eye"}
                ></i>
              </button>
            </div>
          </div>

          {mensaje && (
            <div className="admin-login-alert">
              <i className="bi bi-exclamation-circle"></i>

              <span>{mensaje}</span>
            </div>
          )}

          <button
            type="submit"
            className="admin-login-submit"
            disabled={cargando}
          >
            {cargando ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></span>
                Verificando...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right"></i>
                Iniciar sesión
              </>
            )}
          </button>
        </form>

        <div className="admin-login-footer">
          <i className="bi bi-shield-check"></i>

          <span>Área protegida de G&amp;J Frío Industrial y Doméstico</span>
        </div>

        <button
          type="button"
          className="admin-login-back"
          onClick={() => navigate("/")}
        >
          <i className="bi bi-arrow-left"></i>
          Volver al sitio web
        </button>
      </div>
    </div>
  );
}
